import { render, staticRenderFns } from "./ProviderDetailed.vue?vue&type=template&id=bcf1d3e0&"
import script from "./ProviderDetailed.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports